import React, { useState, createContext } from 'react'

const Context = createContext('')

const ContextProvider = (props) => {

    let localStorageContent = localStorage.getItem('lang') || navigator.language.split('-')[0]
    localStorageContent = (localStorageContent !== 'fr' && localStorageContent !== 'en') ? navigator.language.split('-')[0] : localStorageContent 

    const [lang, setLang] = useState(localStorageContent)

    const switchLang = (langValue) => {
        localStorage.setItem('lang', langValue)
        setLang(langValue)
    }

    return (
        <Context.Provider value={{ lang, switchLang }}>
            {props.children}
        </Context.Provider>
    )

}

export { ContextProvider, Context }


// WEBPACK FOOTER //
// ./src/Component/Context.js